module.exports = __webpack_public_path__ + "img/search-engine.c2071981.webp";